import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-xl-6" }
const _hoisted_4 = { class: "col-xl-6" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col-xl-7 col-lg-6" }
const _hoisted_7 = { class: "col-xl-5 col-lg-6" }
const _hoisted_8 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-xxl-4 col-lg-4" }
const _hoisted_11 = { class: "col-xxl-4 col-lg-4" }
const _hoisted_12 = { class: "col-xxl-4 col-lg-4" }
const _hoisted_13 = { class: "row justify-content-center" }
const _hoisted_14 = { class: "col-lg-8" }
const _hoisted_15 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectsOverview = _resolveComponent("ProjectsOverview")!
  const _component_ProjectsRoadmapChart = _resolveComponent("ProjectsRoadmapChart")!
  const _component_ProjectsProgressChart = _resolveComponent("ProjectsProgressChart")!
  const _component_MyTasks = _resolveComponent("MyTasks")!
  const _component_AllProjects = _resolveComponent("AllProjects")!
  const _component_ProjectsAnalysisChart = _resolveComponent("ProjectsAnalysisChart")!
  const _component_TeamMembers = _resolveComponent("TeamMembers")!
  const _component_WorkingSchedule = _resolveComponent("WorkingSchedule")!
  const _component_ToDoList = _resolveComponent("ToDoList")!
  const _component_TasksOverviewChart = _resolveComponent("TasksOverviewChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProjectsOverview)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ProjectsRoadmapChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ProjectsProgressChart)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_MyTasks)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_AllProjects)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_ProjectsAnalysisChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_TeamMembers)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_WorkingSchedule)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ToDoList)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_TasksOverviewChart)
      ])
    ])
  ]))
}